import React from 'react';
import ExtrasMakeup from './pages/cakeAndMakeup/ExtrasMakeup';
import NotFound from './pages/notFoundPage/NotFound';

const CakeVendorList = React.lazy(() =>
  import('./pages/foodvendor/CakeVendorList')
);
const HomePage = React.lazy(() => import('./pages/landingPage/HomePage'));
const ForgetPasswordPage = React.lazy(() =>
  import('./pages/forgetpassword/ForgetPassword')
);
const ResetPassword = React.lazy(() =>
  import('./pages/resetpassword/ResetPassword')
);

const CartPage = React.lazy(() => import('./pages/cart/cartPage'));

const PackageList = React.lazy(() => import('./pages/packages/PackageList'));
const PackageDetails = React.lazy(() =>
  import('./pages/packages/Details/PackageDetails')
);

const FoodList = React.lazy(() => import('./pages/food/FoodList'));

const DecorationList = React.lazy(() =>
  import('./pages/decoration/DecorationList')
);

const EntertainmentList = React.lazy(() =>
  import('./pages/entertainment/EntertainmentList')
);
const ReturnGiftList = React.lazy(() =>
  import('./pages/returngift/ReturnGiftList')
);
const EmailVerification = React.lazy(() =>
  import('./pages/emailverification/EmailVerification')
);
const EventCoverageList = React.lazy(() =>
  import('./pages/eventcoverage/EventCoverageList')
);

const VenueListing = React.lazy(() => import('./pages/venue/venueList'));
const VenueDetails = React.lazy(() => import('./pages/venue/venueDetails'));

const Contact = React.lazy(() => import('./pages/contact/Contact'));
const About = React.lazy(() => import('./pages/aboutus/About'));
const FoodVendorList = React.lazy(() =>
  import('./pages/foodvendor/FoodVendorList')
);
const ProfilePage = React.lazy(() => import('./pages/profile/ProfileLayout'));
const Cake = React.lazy(() => import('./pages/cakeAndMakeup/Cake'));

const Terms = React.lazy(() => import('./pages/terms/Terms'));
const Privacy = React.lazy(() => import('./pages/terms/Privacy'));
const Refund = React.lazy(() => import('./pages/terms/Refund'));

const WishList = React.lazy(() => import('./pages/wishlist/WishlistPage'));
const OwnPackagePage = React.lazy(() => import('./pages/OwnPackagePage'));


const routes = [
  { path: '/', element: <HomePage />, protected: false },
  { path: '/own-package', element: <OwnPackagePage />, protected: false },

  {
    path: '/verify/:verificationToken',
    element: <EmailVerification />,
    protected: false,
  },
  {
    path: '/forget-password',
    element: <ForgetPasswordPage />,
    protected: false,
  },
  {
    path: '/reset-password/:resetToken',
    element: <ResetPassword />,
    protected: false,
  },


  { path: '/cart', element: <CartPage />, protected: true },
  { path: '/packages', element: <PackageList />, protected: true },
  { path: '/packages/:id', element: <PackageDetails />, protected: true },

  { path: '/venues', element: <VenueListing />, protected: true },
  { path: '/venues/:id', element: <VenueDetails />, protected: true },

  { path: '/decorations', element: <DecorationList />, protected: true },
  { path: '/cakes', element: <CakeVendorList />, protected: true },
  { path: '/extras-item', element: <ExtrasMakeup />, protected: true },

  { path: '/return-gifts', element: <ReturnGiftList />, protected: true },

  { path: '/entertainments', element: <EntertainmentList />, protected: true },

  { path: '/event-coverages', element: <EventCoverageList />, protected: true },

  { path: '/wishlist', element: <WishList />, protected: true },

  { path: '/foodvendors', element: <FoodVendorList />, protected: true },
  { path: '/foods', element: <FoodList />, protected: true },
  { path: '/contact', element: <Contact />, protected: false },
  { path: '/about', element: <About />, protected: false },
  { path: '/profile', element: <ProfilePage />, protected: true },
  { path: '/terms', element: <Terms />, protected: false },
  { path: '/privacy', element: <Privacy />, protected: false },
  { path: '/refund', element: <Refund />, protected: false },
  { path: '/extras', element: <Cake />, protected: false },
  { path: '*', element: <NotFound />, protected: false },
];

export default routes;
